module.exports = __webpack_public_path__ + "img/13.0ccd8f23.svg";